import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	commentedByMe: {
		id: 'search-page.filters.names.commented-by-me',
		defaultMessage: 'Commented by me',
		description: 'Label for filtering for contents commented by the current user',
	},
});
